<template>
    <div>
        <p class="tit">{{ this.$store.state.project.project_name }}</p>
        <p class="comput">机位号：<label>111</label></p>
        <div class="content">
            <div class="login">
                <div class="opac"></div>
                <div class="login_in">
                    <h4>考生登录<label>LOGIN</label></h4>
                    <!-- <div><label>姓名：</label><input type="text" class="user" v-model="form.user_name"></div>
                    <div><label>报名序号：</label><input type="text" class="num" v-model="form.user_signup_no"></div> -->
                    <div v-for="(item,index) in login_item" :key = "index">
                        <label>{{ item.text == '身份证号'?'证件号码':item.text }}:</label>
                        <input type="text" v-model="form[item.value]">
                    </div>

                    <p class="error">{{msg}}</p>
                 
                    <div class="btn">
                        <input type="button" value="登录" class="sub" @click="login">
                        <input type="button" value="重置" class="set">
                    </div>
                </div>
            </div>
        </div>
        <!-- 提示，在后台管理的文本内容新增，文本代码一般为LOGIN -->
        <div class="ql-container ">
            <div v-html="article.article_content" class="ql-editor"></div>
        </div>
        
    </div>
</template>
<script>

export default {
    name: '',
    components: {},
    props:['subject_code'],
    data() {
        return {
            form:{},
            msg:"",
            article:{},//文本提示
            subject:[{subject_name:""}],//科目列表
            is_log:0,//是否记录考生登录日志
            login_item:[]
        }
    },
    created(){
        let subject_list = this.$store.state.exam.subject;
        //let subject_code = this.$route.params.subject_code;
        let subject_code = this.subject_code || this.$route.params.subject_code;
        this.login_item = this.$store.state.config.login_item.map(item => {
            return JSON.parse(item);
        })
     
        //将当前科目存到exam.cur_subject
        for(let i in subject_list){

            if(subject_list[i].subject_code == subject_code){
                this.subject = subject_list[i];
            }
        }

        let exam = this.$store.state.exam;
        
        exam.cur_subject = this.subject;
        this.$store.commit("exam",exam);

        this.getArticle();
        
    },
    methods: {
        getArticle(){
            return this.$req.post("sign/selectLoginArticle",{classify:2}).then(res=>{
                if(res.flag == 1){
                    this.article = res.data.articles[0];
                }
            })
		},
        login(){
            this.msg == '';
            let data = this.form;
            let login_item = this.login_item;
            for(var i in login_item){
                if(!data[login_item[i].value] || data[login_item[i].value] == ''){
                    this.msg = `${login_item[i].text}不能为空`;
                    return false;
                }
            }

            console.log(this.form,'form')
            this.$req.post("sign/in",data).then(res=>{
                if(res.flag == 1){
                    let user={
                        user_id:res.data.user_id,
                        token:res.data.token,
                        ...this.form
                    }
                    let exam = this.$store.state.exam;
                    exam.cur_subject = res.data.subject;
                    this.$store.commit("exam",exam);
                    this.$store.commit("user",user);
                    if(this.$store.state.config.is_log){
                       this.$req.post("log/log_login",{user_id:user.user_id}).then(res=>{
                           if(res.flag == 1){
                                this.toNext();
                           }
                       })
                    }else{
                        this.toNext();
                    }

                    
                }else{
                    this.msg = res.msg;
                }
            })
        },
        toNext(){
            let config = this.$store.state.config;
            if(config.input_test){
                this.$router.push({name:"Test",params:{project_code:this.$store.state.project.project_code}});
            }else{
                this.$router.push({name:"Message",params:{project_code:this.$store.state.project.project_code}});
            }
            
        }
    },
}
</script>
<style lang='scss' scoped src="../assets/css/login.scss"></style>